/* eslint-disable */
export enum CallerType {
  FINNAIRCOM = 'FINNAIRCOM',
  MOBILEAPP = 'MOBILEAPP',
  FINNAIR_HOLIDAY = 'FINNAIR_HOLIDAY',
  UNDEFINED = 'UNDEFINED'
}

